module.exports = __webpack_public_path__ + "img/logo_white.be458521.svg";